import React from "react";

import { Box, Img } from "@chakra-ui/react";
import { ERC721Metadata } from "../../Contexts/ChainbridgeContext";

interface ICustomNFTDisplayProps {
  metadata?: ERC721Metadata;
}

const NFTDisplay: React.FC<ICustomNFTDisplayProps> = ({
  metadata,
}: ICustomNFTDisplayProps) => {
  return (
    <Box
      width="473px"
      bg="white"
      border="1px"
      borderColor="brand.300"
      p="32px"
      textAlign="center"
    >
      {!metadata && <span>Preview will display here once selected!</span>}
      {metadata && (
        <>
          <span>
            <strong>{metadata.name}</strong>
          </span>
          <br />
          <span>{metadata.description}</span>
          <Img src={metadata.image} width="400px" />
        </>
      )}
    </Box>
  );
};

export default NFTDisplay;
